import { RewardLog } from 'types';
import { restService } from 'utilities';

export interface GetRewardLogsInput {
  user?: string;
  fromBlock?: number;
  toBlock?: number | 'latest';
  limit?: number;
}

export interface GetRewardLogsOutput {
  logs: RewardLog[];
}

const getRewardLogs = async ({
  user,
  fromBlock,
  toBlock = 'latest',
  limit = 50,
}: GetRewardLogsInput = {}): Promise<GetRewardLogsOutput> => {
  try {
    const params: Record<string, any> = {
      limit,
    };

    if (user) params.user = user;
    if (fromBlock) params.fromBlock = fromBlock;
    if (toBlock) params.toBlock = toBlock;

    const response = await restService<any>({
      endpoint: '/logs/rewards',
      method: 'GET',
      params,
    });

    // Return empty array if no response
    if (!response?.data) {
      return { logs: [] };
    }

    // Check if data is directly an array
    if (Array.isArray(response.data)) {
      return { logs: response.data };
    }

    // Check if response has nested data array
    if (response.data.data && Array.isArray(response.data.data)) {
      return { logs: response.data.data };
    }

    // Fallback: return empty array
    return { logs: [] };
  } catch (error) {
    console.error('Error fetching reward logs:', error);
    return { logs: [] };
  }
};

export default getRewardLogs;
